<template>
  <div class="loginForm">
    <v-card class="mx-auto" max-width="95%">
      <v-list-item-title class="headline mb-1">
				Profile
				<h1 class="d-sr-only">Profile</h1>
      </v-list-item-title>
      <v-divider></v-divider>
			<v-card-subtitle> Fields marked with * are required.</v-card-subtitle>
      <div>
        <v-form ref="form" align="center" v-model="valid">
					<v-text-field
						v-model="this.userInfo.userName"
            label="Username"
						disabled
						class="disabled-field"
					></v-text-field>
          <v-text-field
						ref="firstFocusable"
            v-model="firstName"
            label="*First Name"
            :rules="firstNameRules"
            required
          ></v-text-field>
          <v-text-field
            v-model="lastName"
            label="*Last Name"
            :rules="lastNameRules"
            required
          ></v-text-field>
          <v-text-field
            v-model="organization"
            label="*Organization"
            :rules="organizationRules"
            required
          ></v-text-field>
          <v-text-field
            v-model="phoneNumber"
            label="Phone Number"
          ></v-text-field>
          <v-text-field
            v-model="email"
            label="*Email"
            :rules="emailRules"
            required
          ></v-text-field>
					<v-btn @click="canceledForm">Cancel</v-btn>
          <v-btn class="btn-default" text :disabled="!valid" @click="submitForm">
            Save
          </v-btn>
        </v-form>

      </div>
    </v-card>
		<v-btn @click="$router.push('/password')">Change Password</v-btn>
  </div>
</template>

<script>

import { researcherApiService } from '@/services/researcherApiService.js';

export default {
	name: 'ProfileForm',
	data: () => ({
		valid: true,
		firstName: null,
		lastName: null,
		organization: null,
		phoneNumber: null,
		email: null,
		firstNameRules: [(v) => !!v || 'First Name is required'],
		lastNameRules: [(v) => !!v || 'Last Name is required'],
		organizationRules: [(v) => !!v || 'Organiation is required'],
		emailRules: [
			(v) => !!v || 'E-mail is required',
			(v) => /.+@.+/.test(v) || 'E-mail must be valid email format'
		],
		saveSuccess: false,
		studyUuid: null,
		studyInfo: null,
		myStudyName: null
	}),
	beforeMount () {
		this.firstName = this.userInfo.firstName;
		this.lastName = this.userInfo.lastName;
		this.organization = this.userInfo.organization;
		this.phoneNumber = this.userInfo.phoneNumber;
		this.email = this.userInfo.email;
	},
	mounted () {
		this.$refs.firstFocusable.focus();
	},
	methods: {
		canceledForm () {
			const me = this;
			me.$router.push('/landing');
		},
		async submitForm () {
			const me = this;
			if (me.studyInfo) {
				me.studyUuid = me.studyInfo.id
			}
			var myUserId = await this.$store.getters.getUserId
			console.log('userID', myUserId)
			const submitObj = await {
				userUuid: myUserId,
				firstName: me.firstName,
				lastName: me.lastName,
				organization: me.organization,
				phoneNumber: me.phoneNumber,
				email: me.email
			}
			await researcherApiService.updateProfile(myUserId, submitObj).then(function (response) {
				me.$store.dispatch('changeUpdateStatus', { status: 'profile-success' });

				// Update store user profile property with the changes that come back from the API call
				var userInfo = response.data
				me.$store.commit('setUserInfo', { userInfo });
			}).catch(function (e) {
				console.log('e.response: ', e.response)
				let errorMessage = 'Change profile failed.';
				if (e.response.data.messages) {
					errorMessage = e.response.data.messages[0]
				}
				me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'register-user-fail', message: errorMessage });
			});
		}
	},
	computed: {
		userInfo: function () {
			return this.$store.getters.getUserInfo;
		}
	}
};
</script>

<style>
.v-text-field,
.v-btn {
  margin: 10px;
}
.disabled-field {
	background-color: #EBEBE4;
}
</style>
